<template>
  <aside class="da-insights">
    <section class="da-insights__card">
      <h3 class="da-insights__title">
        <feather-icon
          icon="ZapIcon"
          size="18"
          class="da-insights__title-icon"
        />
        Principais Insights
      </h3>
      <ul class="da-insights__list">
        <li
          v-for="(item, i) in bullets"
          :key="i"
          class="da-insights__li"
        >
          <span class="da-insights__dot" />
          {{ item }}
        </li>
      </ul>
      <p
        v-if="!bullets.length"
        class="da-insights__empty"
      >
        Insights aparecem quando houver volume suficiente no período selecionado.
      </p>
    </section>

    <section class="da-insights__card">
      <h3 class="da-insights__title">
        <feather-icon
          icon="BookOpenIcon"
          size="18"
          class="da-insights__title-icon"
        />
        Leitura do período
      </h3>
      <p class="da-insights__body">
        {{ leitura }}
      </p>
    </section>

    <section class="da-insights__card">
      <h3 class="da-insights__title">
        <feather-icon
          icon="PieChartIcon"
          size="18"
          class="da-insights__title-icon"
        />
        Distribuição
      </h3>
      <div class="da-insights__bars">
        <div class="da-insights__bar-row">
          <span class="da-insights__bar-label">Resolvidos pelo bot</span>
          <div class="da-insights__track">
            <div
              class="da-insights__fill da-insights__fill--bot"
              :style="{ width: `${distribuicao.pctBot}%` }"
            />
          </div>
          <span class="da-insights__bar-val">{{ distribuicao.pctBotFmt }}</span>
        </div>
        <div class="da-insights__bar-row">
          <span class="da-insights__bar-label">Resolvidos pela equipe</span>
          <div class="da-insights__track">
            <div
              class="da-insights__fill da-insights__fill--hum"
              :style="{ width: `${distribuicao.pctEquipe}%` }"
            />
          </div>
          <span class="da-insights__bar-val">{{ distribuicao.pctEquipeFmt }}</span>
        </div>
        <div class="da-insights__bar-row">
          <span class="da-insights__bar-label">Iniciadas por atendentes</span>
          <div class="da-insights__track">
            <div
              class="da-insights__fill da-insights__fill--ini"
              :style="{ width: `${distribuicao.pctIniciadas}%` }"
            />
          </div>
          <span class="da-insights__bar-val">{{ distribuicao.pctIniciadasFmt }}</span>
        </div>
      </div>
    </section>
  </aside>
</template>

<script>
export default {
  name: 'InsightsDesempenho',
  props: {
    bullets: {
      type: Array,
      default: () => [],
    },
    leitura: {
      type: String,
      default: '',
    },
    distribuicao: {
      type: Object,
      default: () => ({
        pctBot: 0,
        pctEquipe: 0,
        pctIniciadas: 0,
        pctBotFmt: '—',
        pctEquipeFmt: '—',
        pctIniciadasFmt: '—',
      }),
    },
  },
}
</script>

<style scoped>
.da-insights {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
}

.da-insights__card {
  background: #fff;
  border-radius: 22px;
  border: 1px solid #e9dff5;
  box-shadow: 0 10px 30px rgba(80, 45, 120, 0.08);
  padding: 1.35rem 1.4rem;
  transition: box-shadow 0.22s ease, transform 0.22s ease;
}

.da-insights__card:hover {
  box-shadow: 0 14px 30px rgba(80, 45, 120, 0.1);
  transform: translateY(-2px);
}

.da-insights__title {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.85rem;
  font-size: 1rem;
  font-weight: 800;
  color: #3c315b;
  letter-spacing: -0.02em;
  font-family: 'Plus Jakarta Sans', 'Sora', system-ui, sans-serif;
}

.da-insights__title-icon {
  color: #6f35d0 !important;
}

.da-insights__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.da-insights__li {
  position: relative;
  padding-left: 1.1rem;
  margin-bottom: 0.65rem;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #4a4168;
  font-weight: 500;
}

.da-insights__li:last-child {
  margin-bottom: 0;
}

.da-insights__dot {
  position: absolute;
  left: 0;
  top: 0.5rem;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8a46e8, #ff6f61);
}

.da-insights__empty {
  margin: 0;
  font-size: 0.88rem;
  color: #8c84a3;
  line-height: 1.45;
}

.da-insights__body {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #4a4168;
}

.da-insights__bars {
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
}

.da-insights__bar-row {
  display: grid;
  grid-template-columns: 1fr minmax(80px, 120px);
  grid-template-rows: auto auto;
  gap: 0.25rem 0.65rem;
  align-items: center;
}

.da-insights__bar-label {
  grid-column: 1 / -1;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7a7294;
}

.da-insights__track {
  grid-column: 1;
  height: 8px;
  border-radius: 999px;
  background: #ece6f5;
  overflow: hidden;
}

.da-insights__fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.4s ease;
}

.da-insights__fill--bot {
  background: linear-gradient(90deg, #6f35d0, #8a46e8);
}

.da-insights__fill--hum {
  background: linear-gradient(90deg, #6b8af7, #42cfc3);
}

.da-insights__fill--ini {
  background: linear-gradient(90deg, #f5b547, #ff8a65);
}

.da-insights__bar-val {
  grid-column: 2;
  justify-self: end;
  font-size: 0.85rem;
  font-weight: 800;
  color: #5e2bb8;
}
</style>
